import { useState, useEffect, useRef } from 'react';
import { Category } from '../types';

export const useScrollSpy = (categories: Category[], isLoading: boolean) => {
  const [showStickyHeaderInfo, setShowStickyHeaderInfo] = useState(false);
  const [isCategoryDropdownVisible, setIsCategoryDropdownVisible] = useState(true);
  const [currentVisibleCategory, setCurrentVisibleCategory] = useState<string | null>(null);
  const [activeCategoryId, setActiveCategoryId] = useState<string | null>(null);
  const logoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const currentLogoRef = logoRef.current;
    if (!currentLogoRef || isLoading) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowStickyHeaderInfo(!entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '-10px 0px 0px 0px' }
    );

    observer.observe(currentLogoRef);

    return () => {
      if (currentLogoRef) {
        observer.unobserve(currentLogoRef);
      }
    };
  }, [isLoading]);

  useEffect(() => {
    if (isLoading) return;
    
    const handleScroll = () => {
      const filterContainer = document.querySelector('.filter-search-container');
      if (filterContainer) {
        const rect = filterContainer.getBoundingClientRect();
        setIsCategoryDropdownVisible(rect.top > 0);
      }

      if (categories.length > 0) {
        const categorySections = document.querySelectorAll('.category-section');
        for (let i = 0; i < categorySections.length; i++) {
          const rect = categorySections[i].getBoundingClientRect();
          if (rect.top < window.innerHeight / 2 && rect.bottom > 0) {
            const categoryId = categorySections[i].id.replace('category-', '');
            const category = categories.find(cat => cat.id === categoryId);
            if (category) {
              setCurrentVisibleCategory(category.name);
              setActiveCategoryId(categoryId);
            }
            break;
          }
        }
      }
    };

    const rootElement = document.getElementById('root');
    rootElement?.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      rootElement?.removeEventListener('scroll', handleScroll);
    };
  }, [categories, isLoading]);

  return {
    logoRef,
    showStickyHeaderInfo,
    isCategoryDropdownVisible,
    currentVisibleCategory,
    activeCategoryId,
    setActiveCategoryId
  };
};
